import {
  ArrowsChevronUp,
  ArrowsChevronDown,
} from "@fanduel/formation-react-icons";
import { fanduel as fd } from "@fanduel/formation-tokens";
import cx from "classnames";
import Link from "next/link";
import Image from "@/components/Image";
import { NAV_LINK_CLICKED } from "@/constants/amplitude";
import { LinkBehaviour, NestedLink } from "@/graphql/gql/graphql";
import { useAmplitude } from "@/utils/hooks/useAmplitude";
import { filterEmpty } from "@/utils/index";
import Styles from "./MobileMenuItem.module.scss";

type MobileMenuItemProps = NestedLink & {
  setActive: (sport: string) => void;
  activeSport?: string;
  index: number;
};

const MobileMenuItem = ({
  text,
  iconUrl,
  children,
  setActive,
  activeSport,
  index,
}: MobileMenuItemProps) => {
  const { logAmplitudeEvent } = useAmplitude();
  return (
    <li className={Styles.container}>
      <div
        onKeyDown={() => {}}
        role="button"
        tabIndex={index}
        onClick={() => setActive(activeSport === text ? "" : text)}
      >
        <Image
          alt={`${text} icon`}
          src={iconUrl ?? ""}
          height={16}
          width={16}
        />
        {text}
        <div className={Styles.arrowContainer}>
          {activeSport === text ? (
            <ArrowsChevronUp color={fd.colors.coreBlueD1} />
          ) : (
            <ArrowsChevronDown color={fd.colors.coreBlueD1} />
          )}
        </div>
      </div>
      <ul
        className={cx(
          Styles.submenu,
          activeSport === text ? Styles.active : ""
        )}
      >
        {filterEmpty(children ?? []).map((child) => {
          const childUrl = child.url;

          return (
            <li key={child.text}>
              <Link
                target={
                  child?.behaviour === LinkBehaviour.NewWindow
                    ? "_blank"
                    : "_self"
                }
                href={childUrl}
                onClick={() => {
                  logAmplitudeEvent(NAV_LINK_CLICKED, {
                    "Link Text": child.text,
                    "Link URL": childUrl,
                    Module: "navigation_menu",
                    Menu: activeSport ?? "",
                  });
                }}
              >
                {child.text}
              </Link>
            </li>
          );
        })}
      </ul>
    </li>
  );
};

export default MobileMenuItem;
